export const channelTypes = {
  IFRAME: 'On-site chat',
  TELEGRAM: 'Telegram',
  WHATSAPP: 'WhatsApp',
  INSTAGRAM: 'Instagram',
  FACEBOOK: 'Facebook',
  MESSENGER: 'Messenger',
  VIBER: 'Viber',
  ZENDESK: 'Zendesk',
  EMAIL: 'Email',
  SENDPULSE: 'SendPulse',
  ECHAT: 'eChat',
  HELPDESKE: 'Helpdeske',
  INTERCOM: 'Intercom',
  GENESYS: 'Genesys',
};
